//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon7 = 0.0000001;\n\
";
